import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, videos, conselho_etica } from '../../../settings';
import { DelayLink, CardSliderFotos } from '../../../components';

import './ConselhoEtica.scss';

class ConselhoEtica extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };

    this.conselho_etica = conselho_etica.pessoas;
    this.images = images;
    this.videos = videos;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Conselho de Ética - Governança Corporativa - {this.texts.title}</title>
        </Helmet>

        <div className="conselho-etica-home page-gradient page-gradient--green bg-gray" ref="conselho-etica-home">
          <section className="conselho-etica-home-area governanca-header page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-5">
                  <Fade bottom>
                    <div className="page-header">
                      <h1 className="page-header__title">
                        Conselho de <span className="gri_text gri_text--fixed">Ética </span>
                        <span className="gri_label">
                          GRI <b>102-17</b>
                        </span>
                      </h1>
                      <p className="page-header__description">
                        <strong>Sete pessoas fazem parte desse conselho: </strong>são membros de instituições associadas
                        eleitos pela Assembleia Geral em mandatos de dois anos. Eles se dividem em um presidente, um
                        vice-presidente e até cinco conselheiros (em 2019, foram quatro conselheiros), que podem ser
                        reeleitos.
                      </p>
                    </div>
                  </Fade>
                </div>

                <div className="col-7">
                  <img src={this.images.conselho_etica.ilustra1} className="first-image" />
                </div>
              </div>
            </div>
          </section>

          <section className="governanca-body governanca-body--card page--blue">
            <div className="container">
              <div className="row">
                <div className="">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <div className="diretoria-body__content-card">
                        <h2 className="green">Sem número predeterminado de reuniões, esse órgão deve:</h2>
                        <div className="diretoria-body__content-itens">
                          <div>
                            <p>
                              Analisar os pedidos de filiação à ANBIMA e a adesão aos nossos códigos de autorregulação.
                            </p>
                          </div>
                          <div>
                            <p>
                              Interpretar e aplicar o Código de Ética. Também deve instaurar e analisar processos de
                              infração, propondo à Diretoria, quando necessário, penalidades aos associados que
                              descumprirem as normas do código.
                            </p>
                          </div>
                          <div>
                            <p>
                              Elaborar e submeter à Assembleia, por meio da Diretoria, possíveis alterações no Código de
                              Ética.
                            </p>
                          </div>
                        </div>
                      </div>
                    </Fade>

                    <Fade bottom>
                      <h2 className="center-title">Conheça o conselho:</h2>

                      <CardSliderFotos
                        items={this.conselho_etica}
                        url={this.images.conselho_etica.path_url}
                        color={'green'}
                      />
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="conselho-etica-middle-area governanca-middle">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <Fade bottom>
                    <h2 className="big bordered_text bordered_text--dark-gray gri_text gri_text--fixed">
                      Códigos de conduta
                      <span className="gri_label">
                        GRI <b>102-16, 102-17, 102-33</b>
                      </span>
                    </h2>
                  </Fade>
                </div>

                <div className="col-6">
                  <Fade bottom>
                    <div className="card card--yellow">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h3 className="title">Código de Ética ANBIMA</h3>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Voltado para os associados, determina as normas éticas e os padrões de conduta básicos que
                            devem ser seguidos nas atividades profissionais e no relacionamento com clientes e agentes
                            do mercado. Ele trata de temas como concorrência leal, utilização de informações
                            privilegiadas e risco de capacidade de liquidação física ou financeira. Confira o documento{' '}
                            <a
                              href="https://www.anbima.com.br/pt_br/institucional/a-anbima/codigo-de-etica.htm"
                              target="_blank"
                              className="text_link text_link--yellow"
                            >
                              clicando aqui
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-6">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <h3 className="title">Código de Ética e Conduta Profissional </h3>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Destina-se aos funcionários da Associação. Ele aborda políticas corporativas, segurança da
                            informação e investimentos pessoais, citando o uso indevido de informações privilegiadas e
                            conflitos de interesse, entre outros. O código exige atuação íntegra, justa, legal e
                            transparente, e os funcionários assinam um termo para atestar que estão de acordo com o
                            documento no momento da contratação.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="conselho-etica-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--yellow box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-4 col--image">
                            <img
                              src={this.images.conselho_etica.icone1}
                              className="icone_destaque icone_destaque--1--desktop"
                            />
                            <img
                              src={this.images.conselho_etica.icone1_mobile}
                              className="icone_destaque icone_destaque--1--mobile"
                            />
                          </div>
                          <div className="col col-8 col--text">
                            <h4>Conheça nossos organismos de representação</h4>
                            <DelayLink
                              to="/governanca-corporativa/organismos-de-representacao"
                              className="button button--aylen button--white-to-yellow button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { ConselhoEtica };
